
import { Vehicle } from '@clients/myTrips';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BasicSetupScreen from '@components/vehicle-setup/BasicSetupScreen.vue';

@Component({
  name: 'SetupStep6',
  components: {
    BasicSetupScreen,
  }
})
export default class SetupStep6 extends Vue {
  @Prop({ required: true })
  private vehicle: Vehicle;

  @Prop()
  private requestError: string;

  get publicFolder() {
    return process.env.BASE_URL;
  }

  get vehicleModel() {
    return `${this.vehicle.brand} ${this.vehicle.model}`;
  }

  get helpText() {
    return this.requestError ? 'Dieser Fehler tritt mehrmals auf?' : null;
  }
}
